/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLocationOnAzure
 */
export interface UserLocationOnAzure {
    /**
     * 
     * @type {string}
     * @memberof UserLocationOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof UserLocationOnAzure
     */
    user_auth_id: string;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    degrees_bearing?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    meters_per_second_speed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    creation_timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof UserLocationOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserLocationOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof UserLocationOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the UserLocationOnAzure interface.
 */
export function instanceOfUserLocationOnAzure(value: object): value is UserLocationOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('user_auth_id' in value) || value['user_auth_id'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('creation_timestamp' in value) || value['creation_timestamp'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function UserLocationOnAzureFromJSON(json: any): UserLocationOnAzure {
    return UserLocationOnAzureFromJSONTyped(json, false);
}

export function UserLocationOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLocationOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'user_auth_id': json['user_auth_id'],
        'degrees_bearing': json['degrees_bearing'] == null ? undefined : json['degrees_bearing'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'meters_per_second_speed': json['meters_per_second_speed'] == null ? undefined : json['meters_per_second_speed'],
        'creation_timestamp': json['creation_timestamp'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function UserLocationOnAzureToJSON(json: any): UserLocationOnAzure {
    return UserLocationOnAzureToJSONTyped(json, false);
}

export function UserLocationOnAzureToJSONTyped(value?: UserLocationOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'user_auth_id': value['user_auth_id'],
        'degrees_bearing': value['degrees_bearing'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'meters_per_second_speed': value['meters_per_second_speed'],
        'creation_timestamp': value['creation_timestamp'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

